jQuery(document).ready(function ($) {
  function updateVariant(obj) {
    var variant_hdl = obj.parents(".product-step").attr("data-for");
    if (variant_hdl == null) {
      return;
    }
    var variant_sels = $(".product-step[data-for='" + variant_hdl + "']:not(.for_property)");
    var variant_val = "";

    for (var i = 0; i < variant_sels.length; i++) {
      var sel_item = variant_sels.eq(i).find(".step-item.selected");
      var tt;
      if (sel_item.hasClass("step-sel")) {
        tt = sel_item.val();
      }
      else {
        tt = sel_item.attr("data-handle");
      }
      if (i > 0) {
        variant_val += '/';
      }
      variant_val += tt;
    }

    variant_val = variant_val.toLowerCase();

    if ($(".variantSelect option[data-handle='" + variant_val + "']").length <= 0) {
      return;
    }
    $(".variantSelect option[data-handle='" + variant_val + "']").prop("selected", true);
    $(".variantSelect").trigger("change");
  }

  $(".product-step .step-content .step-item:not(.step-sel,.behavior-checkbox)").click(function (e) {
    $(this).parents(".step-content").find(".step-item").removeClass("selected");
    $(this).addClass("selected");
    $(".product-step.step_approve").addClass("hide");
    $(".product-step.not_selected").removeClass("not_selected");
    var this_step = $(this).parents(".product-step");
    var hdl = $(this).attr("data-handle");
    if (this_step.hasClass("step_material")) {
      var material = this_step.find(".step-item.selected").attr("data-handle");
      if (material == 'velvet') {
        $(".product-step:not(.step_material):not(.order-number)").addClass("hide");
        $(".product-step[data-for='" + material + "'][data-for1='" + hdl + "|']").removeClass("hide");
      }
      else {
        $(".product-step:not(.step_material):not(.order-number)").addClass("hide");
        $(".product-step[data-for='" + hdl + "']").removeClass("hide");
      }

      $(".product-step:not(.step_material) .step-item").removeClass("selected");
    }

    var material = $(".product-step.step_material .step-item.selected").attr("data-handle");

    if (material == 'velvet' && this_step.attr("data-handle") == 'text') {
      var steps = $(".product-step[data-for='" + material + "']");
      var key = $(this).attr("data-handle") + "|";

      for (var i = 0; i < steps.length; i++) {
        if (steps.eq(i).attr("data-handle") == 'text') {
          continue;
        }
        if (steps.eq(i).attr("data-for1").includes(key)) {
          steps.eq(i).removeClass("hide");
        }
        else {
          steps.eq(i).addClass("hide");
        }
      }

      $(".product-step.step_approve").removeClass("hide");
    }

    //Show enamel monogram info
    if (material == 'enamel' && $(".enamel-info").length) {
      $(".enamel-info").removeClass("hide");
    } else {
      $(".enamel-info").addClass("hide");
    }

    if (material == 'velvet' && hdl == 'mrs') {
      $(".product-step[data-for='velvet'][data-handle='style'] .step-item[data-handle='-']").trigger("click");
    }

    if (this_step.attr("data-handle") == 'engraving') {
      var step_hdl = $(this).attr("data-handle");
      $(".product-step[data-for='engraving_original']").addClass("hide");
      $(".product-step[data-for='engraving_custom']").addClass("hide");
      $(".product-step[data-for='" + step_hdl + "']").removeClass("hide");
    }

    if ($(this).attr("data-handle") == 'engraving_original') {
      $(".product-step[data-handle='engraving_original-style'] .step-item").eq(0).trigger("click");
    }

    if (this_step.attr("data-handle") == 'engraving_original-style') {
      var img = $(this).find("img");
      var img_html = img.clone();
      var preview_panel = $(".product-step[data-handle='engraving_original-design_customize'] .preview .field-content");
      var img_src = "https://cdn.shopify.com/s/files/1/0362/4005/files/classic.png?v=1614722039";
      var image_exist = false;
      if ($(this).attr("data-tplimg") != null && $(this).attr("data-tplimg").trim() != '') {
        img_src = $(this).attr("data-tplimg");
        image_exist = true;
      }
      preview_panel.html("<div class='img_wrapper'></div>").find(".img_wrapper").html("<img src='" + img_src + "' />");
      if (!image_exist) {
        preview_panel.find('.img_wrapper img').css('opacity', 0);
      }
      preview_panel.find(".img_wrapper").append("<span type='text' data-for='Day' class='preview_input' > </span>");
      preview_panel.find(".img_wrapper").append("<span type='text' data-for='Month' class='preview_input' > </span>");
      preview_panel.find(".img_wrapper").append("<span type='text' data-for='Year' class='preview_input' > </span>");
      preview_panel.find(".img_wrapper").append("<span type='text' data-for='Name1' class='preview_input' > </span>");
      preview_panel.find(".img_wrapper").append("<span type='text' data-for='Name2' class='preview_input' > </span>");
      preview_panel.find(".img_wrapper").append("<span type='text' data-for='Last Name' class='preview_input' > </span>");
      preview_panel.find(".img_wrapper").append("<p data-for='Message' class='preview_input' disabled></p>");

      var field = $(this).attr("data-fields");
      var fields = $(".product-step[data-handle='engraving_original-design_customize'] .properties .field-row");

      for (var i = 0; i < fields.length; i++) {
        var ff = fields.eq(i);
        if (field.includes(ff.attr("data-handle"))) {
          ff.removeClass("hide");
        }
        else {
          ff.addClass("hide");
        }
      }
    }

    updateVariant($(this));

    if ($(".step-item[data-handle='engraving_original']").hasClass("selected")) {
      if ($("#edit-selected-design").prop("checked") == true) {
        $(".product-step[data-handle='engraving']").attr("data-children", $(".variantSelect[data-for='engraving']").val() + "|" + $("#edit-selected-design").val());
      }
      else {
        $(".product-step[data-handle='engraving']").attr("data-children", $(".variantSelect[data-for='engraving']").val());
      }
    }
    else if ($(".step-item[data-handle='engraving_custom']").hasClass("selected")) {
      $(".product-step[data-handle='engraving']").attr("data-children", $(".own_artwork_id").val());
    }

    if (this_step.attr("data-handle") == 'engraving_original-style') {
      updateEngravingDesign($(".product-step[data-handle='engraving_original-design_customize']"));
    }

    showApprovalText();

    $(this).parents(".product-step").removeClass("not_selected");

    var step_inds = $(".product-step:not(.hide) .step-ind");
    for (var i = 0; i < step_inds.length; i++) {
      step_inds.eq(i).text(i + 1);
    }
  });
  $('.auto-select-option .step-item').click();
  $(".sel-initials").change(function (e) {
    var initials = {
      "A": [0, 0],
      "B": [0, 1],
      "C": [0, 2],
      "D": [0, 3],
      "E": [0, 4],
      "F": [1, 0],
      "G": [1, 1],
      "H": [1, 2],
      "I": [1, 3],
      "J": [1, 4],
      "K": [2, 0],
      "L": [2, 1],
      "M": [2, 2],
      "N": [2, 3],
      "O": [2, 4],
      "P": [3, 0],
      "Q": [3, 1],
      "R": [3, 2],
      "S": [3, 3],
      "T": [3, 4],
      "U": [4, 0],
      "V": [4, 1],
      "W": [4, 2],
      "X": [4, 3],
      "Y": [4, 4],
      "Z": [5, 0]
    };

    if ($(this).val() == "0") {
      $(this).removeClass("selected");
      return;
    }
    else {
      $(this).addClass("selected");
      $(this).parents(".product-step").removeClass("not_selected");
    }

    var ind = parseInt($(this).find("option:selected").index()) - 1;
    var row_ind = initials[$(this).val()][0];
    var col_ind = initials[$(this).val()][1];
    var img = $(this).parents(".product-block").find(".product-step:not(.hide) .initials_viewer img");
    var x_step = 0 - img.width() / 5 * col_ind;
    var y_step = 0 - img.height() / 6 * row_ind;

    $(this).parents(".product-block").find(".product-step:not(.hide) .initials_viewer img").css("transform", "translate(" + x_step + "px, " + y_step + "px)");

    if (!$(this).hasClass("step-property_val")) {
      updateVariant($(this));
    }
  });

  $(".step-label.step-monogram_sel").click(function (e) {
    if ($(this).hasClass("selected")) {
      $(this).removeClass("selected");
      $(this).parent().find(".step-content").addClass("hide");
      $(".product-step:not(.step_material):not(.order-number)").addClass("hide");
      $(".product-step[data-for='velvet'] .step-item").removeClass("selected");
      $(".product-step.not_selected").removeClass("not_selected");
      $(this).parents(".product-step").removeClass("hide");
      $(this).find(".step-property_val").val("");
    }
    else {
      $(this).addClass("selected");
      $(this).parent().find(".step-content").removeClass("hide");
      $(this).parent().find(".step-content .step-item:first-child").trigger("click");
    }
  });

  $(".step-label.step-engraving_sel").click(function (e) {
    if ($(this).hasClass("selected")) {
      $(this).removeClass("selected");
      $(this).parent().find(".step-content").addClass("hide");
      $(this).parent().find(".step-content .step-item").removeClass("selected");
      $(".product-step[data-for='engraving_original']").addClass("hide");
      $(".product-step[data-for='engraving_custom']").addClass("hide");
    }
    else {
      $(this).addClass("selected");
      $(this).parent().find(".step-content").removeClass("hide");
      $(this).parent().find(".step-content .step-item:first-child").trigger("click");
    }
  });

  function randomNumber() {
    var count = 2;
    var key = '';
    while (count > 0) {
      key = key + (Math.random() + 1).toString(36).substring(2);
      count--;
    }
    return key;
  }

  function addChildAddonProperties(form,addonProps){
    Object.entries(addonProps).forEach(property => {
      const [key, value] = property;
      form.append('<input type="hidden" class="addon_property" name="properties['+key+']" value="' + value + '"></input>');
    });
  }

  function addParentProduct(formData){
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function (cart) {
        window.postDisabled = false;
        $(".btn.add-to-cart").removeClass("btn--loading");
        window.location.href = '/cart';
      }
    })
  }

  $(".add-to-cart").click(function (e) {
    e.preventDefault();
    if (window.postDisabled) {
      return;
    }
    window.postDisabled = true;
    $(".btn.add-to-cart").addClass("btn--loading");
    var random_num = randomNumber();
    var product_steps = $(".product-step:not(.hide)");
    this.form = $('.product-single__form');
    var ref_key = $('.ref_parent_key').remove();
    $('.addon_property').remove();

    $(this.form).append('<input type="hidden" class="ref_parent_key" name="properties[_ref_key]" value="' + random_num + '"></input>');

    for (var i = 0; i < product_steps.length; i++) {
      var step = product_steps.eq(i);

      if (step.find(".step-item:not(.hide)").length > 0 && step.find(".step-item.selected:not(.hide)").length <= 0) {
        step.addClass("not_selected");
      }
      else if (step.find(".uploadkit").length > 0 && step.find(".uploadkit img").length <= 0) {
        step.addClass("not_selected");
      }
      else if(step.hasClass("required") && step.find('input[required][type="text"]').val().trim() == "") {
        step.addClass("not_selected");
      }
      else {
        step.removeClass("not_selected");
      }
    }

    if ($(".product-step.not_selected").length > 0) {
      $("#has_addon").val("no");

      //Product with no options selected
      if ($(".product-step.not_selected").length == 1 && $(".product-step.not_selected .step-label").hasClass("step-monogram_sel")) {
        $(".product-step.not_selected").removeClass("not_selected");
        var formData = $(this).parents("form").serialize();
        addParentProduct(formData);
      }
      //Metal Finish Product with no engraving selected
      else if ($(".product-step.not_selected").length == 1 && $(".product-step.not_selected .step-label").hasClass("step-engraving_sel")) {
        $(".product-step.not_selected").removeClass("not_selected");
        $("#has_addon").val("yes");
        var form = $(this).parents("form");
        //Add Metal Lid Addon
        var material = $(".product-step.step_material .step-item.selected").attr("data-handle");
        var variant_title = $(".variantSelect[data-for='" + material + "'] option:selected").text();
        var variant_id = $(".variantSelect[data-for='" + material + "']").val();
        var property_steps = $(".product-step.for_property:not(.hide)");
        var property = {};
        property['Metal Finish'] = variant_title ? variant_title : '';

        for (var i = 0; i < property_steps.length; i++) {
          var pt = property_steps.eq(i);

          if (pt.attr("data-property") == '_material') {
            continue;
          }

          var pt_h = pt.attr("data-property");
          var pt_v = pt.find(".step-property_val").val();

          if (pt_h == null) {
            continue;
          }

          property[pt_h] = pt_v;
        }

        addChildAddonProperties(form,property);

        var data = {
          "quantity": 1,
          "id": variant_id,
          "properties": {"_parent":random_num}
        };

        //Add child product
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function (cart) {
            //Add parent product
            var formData = $('.product-single__form').serialize();
            addParentProduct(formData);
          }
        });
        
      }
      else {
        $(".product-step.not_selected .step-label.step-monogram_sel").parent().removeClass("not_selected");
        $(".product-step.not_selected .step-label.step-engraving_sel").parent().removeClass("not_selected");
        $([document.documentElement, document.body]).animate({
          scrollTop: $(".product-step.not_selected").eq(0).offset().top - 100
        }, 200);
        window.postDisabled = false;
        $(".btn.add-to-cart").removeClass("btn--loading");
      }
    }
    else {
      $("#has_addon").val("yes");

      var material = $(".product-step.step_material .step-item.selected").attr("data-handle");
      var variant_title = $(".variantSelect[data-for='" + material + "'] option:selected").text();
      var variant_id = $(".variantSelect[data-for='" + material + "']").val();

      var property_steps = $(".product-step.for_property:not(.hide)");
      var property = {};
      
      for (var i = 0; i < property_steps.length; i++) {
        var pt = property_steps.eq(i);

        if (pt.attr("data-property") == '_material') {
          continue;
        }

        var pt_h = pt.attr("data-property");
        var pt_v = pt.find(".step-property_val").val();

        if (pt_h == null) {
          continue;
        }

        property[pt_h] = pt_v;
      }

      //Get Top Material Addon Data
      var data = {
        "quantity": 1,
        "id": variant_id,
        "properties": {"_parent":random_num}
      };

      var metal_engraving = $(".product-step[data-handle='engraving']");
         
      //IF Engraving
      if (metal_engraving.find(".step-engraving_sel").hasClass("selected") && metal_engraving.find(".step-item.selected").length > 0) {
        property['Metal Finish'] = variant_title ? variant_title : '';
        var form = $(this).parents("form");
        //If engraving design from template
        if (metal_engraving.find(".step-item.selected").attr("data-handle") == 'engraving_original') {
          var engraving_id = $(".product-step[data-handle='engraving_original-style'] .variantSelect").val();
          var property_flds = $(".product-step[data-handle='engraving_original-design_customize'] .properties .field-row:not(.hide)");

          
          if ($("#edit-selected-design").prop("checked") == true) {
            property['Additional Edits'] = 'Yes [+'+$("#edit-selected-design").data("price")+']';
          }

          property['Style'] = $(".product-step[data-handle=engraving_original-style] .step-content .step-item.selected").attr("data-handle");

          for (var i = 0; i < property_flds.length; i++) {
            var pt1 = property_flds.eq(i).find(".js-option-field");
            var pt_h1 = pt1.attr("data-property");
            var pt_v1 = pt1.val();

            property[pt_h1] = pt_v1;
          }
          
          //Get Engraving Addon Data
          var data1 = {
            "quantity": 1,
            "id": engraving_id,
            "properties": {"_parent":random_num}
          };

          //Add top material addon to cart
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (cart1) {
              //Add engraving addon to cart
              jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data1,
                dataType: 'json',
                success: function (cart2) {

                  //If custom engraving design
                  if ($("#edit-selected-design").prop("checked") == true) {
                    var custom_design_id = $("#edit-selected-design").val();
                    
                    var data2 = {
                      "quantity": 1,
                      "id": custom_design_id,
                      "properties": { "_parent": random_num }
                    };
                    
                    addChildAddonProperties(form,property);

                    jQuery.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: data2,
                      dataType: 'json',
                      success: function (cart3) {
                        //Add parent product
                        var formData = $('.product-single__form').serialize();
                        addParentProduct(formData);
                      }
                    });
                  }
                  else {
                    addChildAddonProperties(form,property);
                    //Add parent product
                    var formData = $('.product-single__form').serialize();
                    addParentProduct(formData);
                  }
                }
              });
            }
          });
        }
        else if (metal_engraving.find(".step-item.selected").attr("data-handle") == 'engraving_custom') {
          //Upload own artwork addon 
          var data1 = {
            "quantity": 1,
            "id": $(".own_artwork_id").val(),
            "properties": {"_parent":random_num}
          };

          property['Engraving Design'] = 'Own Design';
          property['Design File'] = $(".own_artwork-uploader .uploadkit-attribute-container input").attr("value");

          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (cart1) {
              //Add own artwork addon
              jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data1,
                dataType: 'json',
                success: function (cart3) {
                  addChildAddonProperties(form,property);
                  //Add parent product
                  var formData = $('.product-single__form').serialize();
                  addParentProduct(formData);
                }
              });
            }
          });
        }
      }else {
        var monogramData = variant_title.split('/');
        property['Monogram'] = monogramData[0] ? monogramData[0].trim() : '';

        if (monogramData[1] && monogramData[1].trim()  != '-'){
        property['Monogram Style'] = monogramData[1].trim();
        }
          
        property['Foil Color'] = monogramData[2] ? monogramData[2].trim() : '';
        if(property.hasOwnProperty("Initial")){
        delete Object.assign(property, {["Letter"]: property["Initial"] })["Initial"];
        }
            
        if(data.id == undefined){
          window.postDisabled = false;
          $(".btn.add-to-cart").removeClass("btn--loading");
          //Remove parent refkey if no top material
          var ref_key = $('.ref_parent_key').remove();
          //Add parent product
          var formData = $('.product-single__form').serialize();
          addParentProduct(formData);
        }else{
          var form = $(this).parents("form");
          addChildAddonProperties(form,property);
          //Add top material addon
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (cart1) {
              //Add parent product
              var formData = $('.product-single__form').serialize();
              addParentProduct(formData);
            }
          });
        }
      }
    } 
  });

  $(".product-step[data-property='Monogram'] .step-item").click(function (e) {
    $(this).parents(".product-step").find(".step-property_val").val($(this).attr("data-handle"));
  });

  $("#edit-selected-design").change(function (e) {
    if ($("#edit-selected-design").prop("checked") == true) {
      $(".product-step[data-handle='engraving']").attr("data-children", $(".variantSelect[data-for='engraving']").val() + "|" + $("#edit-selected-design").val());
    }
    else {
      $(".product-step[data-handle='engraving']").attr("data-children", $(".variantSelect[data-for='engraving']").val());
    }
  });

  $("[data-handle='engraving_original-design_customize'] .properties .js-option-field").bind('keyup change', function (e) {
    updateEngravingDesign($(".product-step[data-handle='engraving_original-design_customize']"));
  });

  function updateEngravingDesign(panel) {
    var style = $("[data-handle='engraving_original-style'] .variantSelect option:selected").attr("data-handle");
    var year = panel.find(".js-option-field[data-property='Year']").val();
    var month = panel.find(".js-option-field[data-property='Month']").val();
    var day = panel.find(".js-option-field[data-property='Day']").val();
    var name1 = panel.find(".js-option-field[data-property='Name1']").val();
    var name2 = panel.find(".js-option-field[data-property='Name2']").val();
    var lastname = panel.find(".js-option-field[data-property='Last Name']").val();
    var message = panel.find(".js-option-field[data-property='Message']").val();

    switch (style) {
      case "style - 1":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '56', 'ChopinScript', '49%', '49%', '', 0]]);
        break;
      case "style - 2":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '68', 'Marbre', '52%', '56%', '', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase(), '9', 'Luxury Diamond', '50%', '17%', '', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.toUpperCase(), '9', 'Luxury Diamond', '50%', '83%', '', 0]]);
        break;
      case "style - 3":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '67', 'Voga', '50%', '45%', '', 0]]);
        break;
      case "style - 4":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase() + ' & ' + name2.toUpperCase(), '11', 'Gotham', '49%', '26%', 'initial', 0]],'',1.2);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toLowerCase(), '69', 'Faustine', '52%', '46%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '11', 'Gotham', '50%', '74%', 'initial', 0]],'',1.5);
        break;
      case "style - 5":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase() + ' & ' + name2.toUpperCase(), '11', 'Luxury Diamond', '50%', '73%', '', 0]],'',1.5);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '109', 'GentleWhisper Floral', '49%', '48%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '11', 'Luxury Diamond', '50%', '82%', 'initial', 0]],'',1.5);
        break;
      case "style - 6":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname, '53', 'Faustine', '49%', '49%', 'initial', 0]],'',-0.5);
        break;
      case "style - 7":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '102', 'ChopinScript', '47%', '52%', 'initial', 0]]);
        break;
      case "style - 8":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Year", "EST. " + year, '11', 'Gotham Book', '50%', '69%', '600', 0]], '', 3, '');
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toLowerCase(), '21', 'Bodoni Sans', '50%', '50%', 'initial', 0]], '', 1.5, '');
        break;
      case "style - 9":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '117', 'Voga', '50%', '44%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '28.5', 'Neutraface Medium', '35%', '46%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '28.5', 'Neutraface Medium', '66%', '45.5%', 'initial', 0]]);
        break;
      case "style - 10":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '67', 'Monogram kk sc', '48%', '51%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '48', 'Monogram kk sc', '37.5%', '50%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '48', 'Monogram kk sc', '62%', '50%', 'initial', 0]]);
        break;
      case "style - 11":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toUpperCase(), '12', 'Luxury Diamond', '49.8%', '51.2%', 'initial', 0]]);
        break;
      case "style - 12":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toUpperCase(), '16', 'MrEavesXLSanNarOT', '49.6%', '49.6%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '16.5', 'MrEavesXLSanNarOT', '50%', '35.5%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '16.5', 'MrEavesXLSanNarOT', '50%', '64.3%', 'initial', 0]]);
        break;
      case "style - 13":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Year", year, '11', 'Gotham', '64%', '35.5%', 'initial', 0, 1]],'',1);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '33', 'Bodoni Sans', '52%', '65%', 'initial', 0]]);
        break;
      case "style - 14":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Year", "EST. " + year, '9', 'Futura Std', '52%', '86%', 'initial', 0]], '', 1.7);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase() + ' & ' + name2.toUpperCase(), '13', 'Futura Std', '51%', '77%', 'initial', 0]], '', 2.5);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '49', 'Hello Paris Serif', '52%', '35%', 'initial', 0]]);
        break;
      case "style - 15":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Message", message.toUpperCase(), '11', 'Gotham', '50%', '50%', 'initial', 0]], 60, 1, 19);
        break;
      case "style - 16":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase() + ' & ' + name2.toUpperCase(), '16.5', 'Futura Std', '50%', '72%', '300', 0]],'',1.6);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '71', 'Rare Bird Specimen I', '48%', '39%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '11', 'Gotham Book', '50%', '81%', 'initial', 0]]);
        break;
      case "style - 17":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toLowerCase(), '64', 'Faustine', '46%', '50%', 'initial', 0]]);
        panel.find('.preview .img_wrapper [data-for="Last Name"]').css('transform', 'translate(-50%, -50%) rotate(-9deg)');
        break;
      case "style - 18":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase(), '29', 'Bon Vivant Serif', '50%', '41%', 'normal', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", '& ' + name2.toLowerCase(), '28', 'Chiswick Poster', '51%', '51%', 'initial', 0]]);
        break;
      case "style - 19":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toUpperCase(), '20', 'Bon Vivant Serif', '49.5%', '51.5%', 'initial', 0]],'',0.5);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '11', 'Gotham', '50%', '39%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '11', 'Gotham', '50%', '62%', 'initial', 0]]);
        break;
      case "style - 20":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '66', 'Hello Paris Serif', '29%', '45.5%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toLowerCase(), '66', 'Hello Paris Serif', '69%', '45.5%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", 'THE ' + lastname.toUpperCase() + 'S', '11', 'Futura Std', '50%', '26.3%', 'initial', 0]], '', 2.3);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '10.5', 'Futura Std', '50%', '74%', 'initial', 0]], '', 2);
        break;
      case "style - 21":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", "THE", '11', 'Futura Std', '50.5%', '20%', '500', 0]],'',2);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", lastname.toUpperCase() + "S", '11', 'Futura Std', '51%', '28%', '500', 0]],'',2.4);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '71', 'Hello Paris Serif', '48%', '46%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '11', 'Futura Std', '50%', '78%', 'initial', 0]],'',2);
        break;
      case "style - 22":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '110', 'Rare Bird Specimen I', '49%', '49%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '13', 'ITC Blair', '49.5%', '76.6%', 'initial', 0]],'',2);
        break;
      case "style - 23":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '102', 'Rare Bird Specimen II', '44%', '37%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '102', 'Rare Bird Specimen II', '61%', '54%', 'initial', 0]]);
        break;
      case "style - 24":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '50', 'Bodoni Sans', '37%', '45%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '50', 'Bodoni Sans', '66%', '45%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toUpperCase(), '11', 'Gotham', '50%', '26%', 'initial', 0]], '', 3.1);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '&#183;' + day + '&#183;' + year.substring(2, 4), '11', 'Gotham', '50%', '74%', 'initial', 0]], '', 4);
        break;
      case "style - 25":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '19', 'Cantoria MT Std', '50%', '30%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '19', 'Cantoria MT Std', '50%', '70%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.toUpperCase(), '19', 'Cantoria MT Std', '50%', '49%', 'initial', 0]],'',2);
        break;
      case "style - 26":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '160', 'Floralista', '50%', '58%', 'initial', 0]]);
        break;
      case "style - 27":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", lastname.toUpperCase() + "S", '28', 'Bon Vivant Serif', '50%', '50%', '600', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", "the", '28', 'Chiswick Poster', '50%', '34%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '18', 'BodoniCond', '50%', '67%', 'initial', 0]],'',2);
        break;
      case "style - 28":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase() + ' &', '17', 'Futura Std', '35%', '71.5%', '300', 0]],'',1.5);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.toUpperCase(), '17', 'Futura Std', '35%', '81%', '300', 0]],'',1.5);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '73', 'Bon Vivant Serif', '49%', '55.5%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Year", year, '11', 'Gotham', '66%', '32%', 'initial', 0]],'',3);
        break;
      case "style - 29":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toLowerCase(), '87', 'MFC Baelon Monogram', '50%', '50%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '87', 'MFC Baelon Monogram', '50%', '51%', 'initial', 0]]);
        break;
      case "style - 30":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '89', 'Voga', '50%', '43%', 'initial', 0]]);
        break;
      case "style - 31":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '44', 'Kontor', '41%', '38%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '44', 'Kontor', '60%', '38%', 'initial', 0]]);
        break;
      case "style - 32":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '33', 'Futura Std', '22%', '44%', '300', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '33', 'Futura Std', '77%', '44%', '300', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '112', 'Gotham', '49%', '45%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", lastname.toUpperCase(), '10', 'Gotham', '50%', '76%', 'initial', 0]], '', 3.6, '');
        panel.find('.preview .img_wrapper [data-for="Last Name"]').addClass('transparent-text');
        break;
      case "style - 33":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '62', 'Monogram kk sc', '51%', '35%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase() + ' & ' + name2.toUpperCase(), '17', 'Futura Std', '49%', '71.5%', '300', 0]],'',1.5);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", month + '.' + day + '.' + year.substring(2, 4), '13', 'Futura Std', '48%', '80%', 'initial', 0]],'',0.8);
        break;
      case "style - 34":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.substring(0, 1).toUpperCase(), '71', 'Monogram kk sc', '23%', '50%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.substring(0, 1).toUpperCase(), '71', 'Monogram kk sc', '75%', '50%', 'initial', 0]]);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '108', 'Monogram kk sc', '50%', '50%', 'initial', 0]]);
        break;
      case "style - 35":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Day", 'EST.', '11.5', 'Gotham', '25%', '50%', 'initial', 0]],'',3);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Month", 'THE', '11.5', 'Gotham', '50%', '19%', 'initial', 0]],'',3);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Year", year, '11.5', 'Gotham', '77%', '50%', 'initial', 0]],'',3);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", lastname.toUpperCase() + 'S', '11.5', 'Gotham', '50%', '80%', 'initial', 0]],'',2.5);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname.substring(0, 1).toUpperCase(), '110', 'Monogram kk sc', '50%', '51%', 'initial', 0]]);
        break;
      case "style - 36":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name1", name1.toUpperCase(), '13', 'Bon Vivant Serif', '50%', '24%', 'bold', 0]], '', 4);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Name2", name2.toUpperCase(), '13', 'Bon Vivant Serif', '50%', '77%', 'bold', 0]], '', 4);
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Last Name", lastname, '42', 'Bon Vivant Serif', '51%', '50.5%', '600', 0]],'',1.9);
        break;
      case "style - 37":
        renderEngravingText(panel.find(".preview .img_wrapper"), [["Message", message, '43', 'Bon Vivant Regular', '50%', '46.5%', 'initial', 0]], '', -1, 39);
        break;
    }
  }

  function renderEngravingText(panel, arr, max_width, letterspacing, lineheight) {
    for (var i = 0; i < arr.length; i++) {
      var handle = arr[i][0];
      var letter = arr[i][1];
      var font_size = arr[i][2];
      var font_family = arr[i][3];
      var xpos = arr[i][4];
      var ypos = arr[i][5];
      var weight = arr[i][6]
      var multiline = arr[i][7];
      var vertical = arr[i][8];

      var css = "left: " + xpos + "%; top: " + ypos + "%; font-family: " + font_family + "; font-size: " + font_size + "px; width: " + (font_size * letter.length) * 4 / 3 + "px; font-weight: " + weight;
      var inp = panel.find(".preview_input[data-for='" + handle + "']");
      inp.css("left", xpos);
      inp.css("top", ypos);
      inp.css("font-family", font_family);
      inp.css("font-size", font_size + "px");
      inp.css("width", (font_size * letter.length) * 4 / 3 + "px");
      inp.css("font-weight", weight);
      if (max_width) {
        inp.css("max-width", max_width);
      }
      if (letterspacing) {
        inp.css("letter-spacing", letterspacing);
      }
      if (lineheight) {
        inp.css("line-height", lineheight + 'px');
      }
      if (vertical == 1) {
        inp.css("writing-mode", 'vertical-rl');
        inp.css("text-orientation", 'upright');
      }

      if (multiline == 1) {
        inp.html(letter);
        inp.css("width", "100px");
      }
      else {
        inp.html(letter);
        inp.css("text-align", "center");
      }
    }
  }



  function showApprovalText() {
    var selectedMaterial = $(".product-step.step_material .step-item.selected").attr("data-handle");
    var isMonogram = $('.product-step:not(.hide) .step-monogram_sel.selected').length;
    var isEnagraving = $('.product-step[data-handle="engraving"]:not(.hide) .step-item.selected[data-handle="engraving_original"]').length;

    if ((selectedMaterial == 'velvet' && isMonogram) || (selectedMaterial == 'metal' && isEnagraving) || (selectedMaterial == 'enamel')) {
      $(".product-step.step_approve").removeClass("hide");
      $(".product-step.step_approve span:not(.step-ind)").addClass("hide");
      if (isMonogram) {
        $(".product-step.step_approve").find('.velvet-approval').removeClass("hide");
      } else if (isEnagraving) {
        $(".product-step.step_approve").find('.metal-engraving-approval').removeClass("hide");
      } else {
        $(".product-step.step_approve").find('.enamel-approval').removeClass("hide");
      }
    }
  }

});

$('.additional-edits,.step_approve .step-item').click(function (e) {
  $(this).toggleClass('selected');
});

$(".step-item,.price_addon").click(function (e) {
  setTimeout(calculatePrice, 500);
});

function calculatePrice() {
  var price_handle_array = $("[data-product-price]");
  var current_price = parseFloat(price_handle_array.attr("data-price"));
  var addon_price = 0;
  $('.selected.price_addon:visible').each(function () {
    addon_price += parseInt($(this).attr("data-addon-price"));
  })

  var money_format = theme.settings.moneyFormat;
  var total_price = current_price + addon_price;
  for (var i = 0; i < price_handle_array.length; i++) {
    var price_hd = price_handle_array.eq(i);
    price_hd.text(theme.Currency.formatMoney(total_price, money_format));
  }

  var priceSaleEl = document.querySelector("[data-product-price-sale]");
  if(priceSaleEl){
    console.log('PRICE SALE')
    var currentSalePrice = parseFloat(priceSaleEl.dataset.price);
    priceSaleEl.innerText = theme.Currency.formatMoney(currentSalePrice+addon_price, money_format);
  }
}



